import HelloWorld from '../components/HelloWorld.vue'
import { bootstrapPage } from '../bootstrapPage'

bootstrapPage(HelloWorld)
